class RewardReportParse {
    totalsMap = {};
    departmentsMap = {};
    personsMap = {};
    bonusesMap = {};
    totals;
    departments;
    constructor(data) {
        this.totalsMap = {};
        this.departmentsMap = {};
        this.personsMap = {};
        this.bonusesMap = {};
        data?.forEach((bonusEntry) => {
            this.incrementTotals(bonusEntry);
            this.parseRow(bonusEntry);
        });
        this.totals = Object.values(this.totalsMap);
        this.departments = this.getFlatReport();
    }
    parseRow(bonusEntry) {
        const bonus = this.updateBonusesMapAndGetBonusLink(bonusEntry);
        const person = this.updatePersonsMapAndGetPersonLink(bonusEntry, bonus);
        const departmentId = bonusEntry.Department.Id;
        if (this.departmentsMap[departmentId]) {
            if (!this.departmentsMap[departmentId].persons[person._id]) {
                this.departmentsMap[departmentId].persons[person._id] = this.personsMap[person._id];
            }
            this.departmentsMap[departmentId].totals.monetaryAmount += bonus.isMonetary ? bonus.amount : 0;
            this.departmentsMap[departmentId].totals.nonMonetaryAmount += !bonus.isMonetary ? bonus.amount : 0;
        }
        else {
            const departmentName = bonusEntry.Department?.Name || 'N/A';
            this.departmentsMap[departmentId] = {
                departmentId,
                departmentName,
                persons: {
                    [person._id]: this.personsMap[person._id]
                },
                totals: {
                    monetaryAmount: bonus.isMonetary ? bonus.amount : 0,
                    nonMonetaryAmount: !bonus.isMonetary ? bonus.amount : 0
                }
            };
        }
    }
    getPersonMapId(bonusEntry) {
        const userId = bonusEntry.PersonBonus?.PersonId;
        const departmentId = bonusEntry.DepartmentId;
        const { Firstname, Lastname } = bonusEntry.PersonBonus?.Person || {};
        const personName = `${Firstname}-${Lastname}`.trim();
        return `${personName}-${userId}-${departmentId}`;
    }
    getBonusMapId(bonusEntry) {
        const bonusId = bonusEntry.PersonBonus.BonusId;
        const departmentId = bonusEntry.DepartmentId;
        const personId = bonusEntry.PersonBonus?.PersonId;
        const bonusName = bonusEntry.PersonBonus?.Bonus?.Name;
        return `${bonusName}-${bonusId}-${personId}-${departmentId}`;
    }
    bonusEntryToPersonBonus(bonusEntry) {
        return {
            _id: this.getBonusMapId(bonusEntry),
            name: bonusEntry.PersonBonus?.Bonus?.Name || 'N/A',
            unit: bonusEntry.PersonBonus?.Bonus?.Unit || 'N/A',
            amount: bonusEntry.Amount || 0,
            isMonetary: !bonusEntry.PersonBonus?.Bonus?.NonMonetary
        };
    }
    updateBonusesMapAndGetBonusLink(bonusEntry) {
        const bonus = this.bonusEntryToPersonBonus(bonusEntry);
        if (this.bonusesMap[bonus._id]) {
            this.bonusesMap[bonus._id].amount += bonus.amount;
        }
        else {
            this.bonusesMap[bonus._id] = bonus;
        }
        return bonus;
    }
    updatePersonsMapAndGetPersonLink(rawBonusEntry, parsedBonusEntry) {
        const personMapId = this.getPersonMapId(rawBonusEntry);
        const { isMonetary } = parsedBonusEntry;
        if (this.personsMap[personMapId]) {
            if (!this.personsMap[personMapId].bonuses[parsedBonusEntry._id]) {
                this.personsMap[personMapId].bonuses[parsedBonusEntry._id] = this.bonusesMap[parsedBonusEntry._id];
            }
            this.personsMap[personMapId].totals.monetaryAmount += isMonetary ? parsedBonusEntry.amount : 0;
            this.personsMap[personMapId].totals.nonMonetaryAmount += !isMonetary ? parsedBonusEntry.amount : 0;
        }
        else {
            const { Firstname, Lastname } = rawBonusEntry.PersonBonus?.Person || {};
            const personName = `${Firstname} ${Lastname}`;
            this.personsMap[personMapId] = {
                _id: personMapId,
                personId: rawBonusEntry.PersonBonus?.Person?.Id,
                personName,
                bonuses: {
                    [parsedBonusEntry._id]: this.bonusesMap[parsedBonusEntry._id]
                },
                totals: {
                    monetaryAmount: isMonetary ? parsedBonusEntry.amount : 0,
                    nonMonetaryAmount: !isMonetary ? parsedBonusEntry.amount : 0
                }
            };
        }
        return this.personsMap[personMapId];
    }
    incrementTotals(bonusEntry) {
        const bonusId = bonusEntry.PersonBonus?.Bonus?.Id;
        const bonusName = bonusEntry.PersonBonus?.Bonus?.Name || 'N/A';
        const bonusUnit = bonusEntry.PersonBonus?.Bonus?.Unit || 'N/A';
        const amount = bonusEntry.Amount || 0;
        const totals = this.totalsMap[bonusId];
        if (totals) {
            totals.amount += amount;
        }
        else {
            this.totalsMap[bonusId] = {
                bonusName,
                amount,
                unit: bonusUnit
            };
        }
    }
    getFlatReport() {
        return Object.values(this.departmentsMap)
            .map((department) => ({
            ...department,
            persons: Object.values(department.persons)
                .map((person) => ({
                ...person,
                bonuses: Object.values(person.bonuses)
            }))
        }));
    }
}
export default RewardReportParse;
